import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from './ui/button';

export const ImageLightbox = ({ isOpen, imageUrl, altText = '', onClose }) => {
  // Handle ESC key
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    
    // Prevent body scroll when lightbox is open
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 animate-in fade-in duration-200"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Visualização de imagem"
    >
      {/* Close button */}
      <Button
        variant="outline"
        size="sm"
        className="absolute top-4 right-4 bg-white/90 hover:bg-white text-slate-900 border-slate-200"
        onClick={onClose}
        aria-label="Fechar"
      >
        <X className="h-4 w-4 mr-2" />
        Fechar
      </Button>

      {/* Image container */}
      <div
        className="relative max-w-[90vw] max-h-[90vh] p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={imageUrl}
          alt={altText}
          className="max-w-full max-h-[90vh] w-auto h-auto object-contain rounded-lg shadow-2xl"
        />
        
        {/* Alt text caption if available */}
        {altText && (
          <div className="absolute bottom-0 left-0 right-0 bg-black/70 text-white text-sm p-3 rounded-b-lg">
            {altText}
          </div>
        )}
      </div>
    </div>
  );
};
